import { TriggerType } from 'common/flow/constants/TriggerType'

export const InteractableTriggerTypes = [
  TriggerType.WIDGET,
  TriggerType.KEYWORD,
  TriggerType.AI_INTENT,
  TriggerType.RULE,
  TriggerType.EXTERNAL_TRIGGER,
  TriggerType.DEFAULT_REPLY,
  TriggerType.CART_REPLY,
  TriggerType.WELCOME_MESSAGE,
  TriggerType.STORY_MENTION_REPLY,
]
